import { Injectable } from '@angular/core';
import { CanActivate, UrlTree, Router } from '@angular/router';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  
  constructor(private router: Router) {}

  canActivate(): boolean | UrlTree {
    if (environment.currentUser != null) {
      switch (environment.currentUser.role) {
        case 1:
          return true;
        case 3:
          return false;
        default:
          return this.router.createUrlTree(['/auth2/loginBook']);
      }
    } else {
      return this.router.createUrlTree(['/auth2/loginBook']);
    }
  }
  
}
